import { generalAxiosInstance } from "../axios/axiosConfig";

export async function GetVendorManagers() {
  try {
    const response = await generalAxiosInstance.get("/GetVendorManagers");
    return response.data;
  } catch (error) {
    return error.response?.data || "An error occurred";
  }
}
